




























import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { ProductTab } from '@/models/Product';

@Component
export default class BathroomColorsTab extends Vue {
    @Prop()
    protected tab!: ProductTab;

    constructor() {
        super();
    }
}
